/*
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
*/
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';

const template = html`
		<style include="app-styles">
            .img-width{
                width:100%;
            }
        </style>
        
        <div class="mdl-grid">
            <div class="mdl-cell mdl-cell--12-col">				
                <img alt="no user image"  src="{{imageBaseUrl}}/node_modules/speedboat_ui/images/{{tenantId}}/sb_images/new_user_dashboard.png" class="img-width"/>
            </div>
            <div class="mdl-cell mdl-cell--12-col secondary-dark-text-xl">
                <oe-i18n-msg msgid="m_DashboardMessage5"></oe-i18n-msg>
            </div>
            <div class="mdl-cell mdl-cell--12-col">
                <div class="secondary-dark-text-s">
                    <oe-i18n-msg msgid="m_DashboardMessage6"></oe-i18n-msg>
                </div>
                <div class="text-align-right">
                    <paper-button class=" padding-r-zero text-brand-color">
                        <oe-i18n-msg msgid="b_AddFunds"></oe-i18n-msg>
                    </paper-button>
                </div>
            </div>            
        </div>`;
        
        Polymer({
            is: 'new-user-info-section'  ,
            _template:template,
              properties: {
                imageBaseUrl: {
                type: String,
                value: window.OEUtils.baseurl
            },
            tenantId: {
                type: String,
                value: sessionStorage.getItem("tenantId")
            }
        }
		});
	